'use client';

import NotFound from '@/legacy/routes/not-found';

export default function NotFoundPage() {
  return <NotFound />;
}
